import { FormikErrors, useFormikContext } from 'formik';
import { FC, useEffect } from 'react';

type Props = {
  onError: (success: boolean, reasons?: string[]) => void;
};

/**
 * Allow to track submit error attempts and provide errors for tracking purposes
 * @returns
 */
export const FormikOnErrorTracking: FC<Props> = ({ onError }) => {
  const { submitCount, isValid, errors } = useFormikContext();

  useEffect(() => {
    if (isValid) return;
    onError(false, mapFormikErrors(errors));
  }, [submitCount]);

  return null;
};

export const mapFormikErrors = (errors: FormikErrors<any>): string[] => formatErrors(errors);

const formatErrors = (errors: FormikErrors<any>, keyPrepend: string = ''): string[] => {
  const result: string[] = [];
  const errorKeys = Object.keys(errors);
  // eslint-disable-next-line no-restricted-syntax
  for (const key of errorKeys) {
    if (key in errors) {
      if (typeof errors[key] === 'string') {
        result.push(`${formatErrorKey(key, keyPrepend)}: ${errors[key]}`);
      } else if (Array.isArray(errors[key])) {
        result.push(
          ...(errors[key] as string[]).map(
            (error, index) => `${formatErrorKey(`${key}[${index}]`, keyPrepend)}: ${error}`,
          ),
        );
      } else if (!Array.isArray(errors[key])) {
        result.push(...formatErrors(errors[key] as FormikErrors<any>, formatErrorKey(key, keyPrepend)));
      }
    }
  }

  return result;
};

const formatErrorKey = (key: string, keyPrepend: string = '') => `${keyPrepend !== '' ? `${keyPrepend}.` : ''}${key}`;
